(() => {
  const GENERIC_GUIDE = "https://support.avantree.com/hc/en-us/articles/61318773566873-How-to-Join-Broadcast-with-Hearing-Aids";
  const DIRECT_INSTRUCTION = "Open your hearing-aid app and join the venue broadcast.";
  const NO_DIRECT_SUPPORT = "Direct Auracast is not currently supported for this brand.";
  const COMING_SOON_GUIDES = new Set(["Amplifon", "Audibel", "Danavox", "Interton"]);
  const BRAND_GUIDES = {
    Beltone: {
      url: "https://avantree.com/pages/beltone-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b8bef32bbf6ac360a61567.png?ts=1784622511273",
      models: ["Commence", "Envision", "Serene"]
    },
    Bernafon: {
      url: "https://avantree.com/pages/bernafon-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b8bf132bbf6ac360a620d7.png?ts=1774590015886",
      models: ["Encanta"]
    },
    Jabra: {
      url: "https://avantree.com/pages/jabra-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b92123caec56d992a84032.png?ts=1778634983680",
      models: ["Enhance Pro 20", "Enhance Pro 30", "Enhance Select 500"]
    },
    Oticon: {
      url: "https://avantree.com/pages/oticon-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69a78c03df52a20580380f32.png?ts=1774520463225",
      models: ["Intent", "Zeal"]
    },
    Philips: {
      url: "https://avantree.com/pages/philips-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b9213910af80322e525bbd.png?ts=1774520398641",
      models: ["HearLink 9050"]
    },
    Phonak: {
      url: "https://avantree.com/pages/phonak-hearing-aids-auracast-guide",
      models: []
    },
    ReSound: {
      url: "https://avantree.com/pages/resound-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b9215eb0b6d7294e7cb711.png?ts=1778635190636",
      models: ["Enzo IA", "Nexia", "Savi", "Vivia"]
    },
    Starkey: {
      url: "https://avantree.com/pages/starkey-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69b27be57c4f35775b409e40.png?ts=1781746108000",
      models: ["Edge AI", "Genesis AI", "Omega AI"]
    },
    Widex: {
      url: "https://avantree.com/pages/widex-hearing-aids-auracast-guide",
      cover: "https://genially-thumbnails.genially.com/69c5fb4b00b557dea7751c47.png?ts=1774600245504",
      models: ["Allure"]
    },
    Cochlear: {
      url: "https://avantree.com/pages/cochlear-hearing-aids-auracast-guide",
      models: []
    },
    Danalogic: {
      url: "https://avantree.com/pages/danalogic-hearing-aids-auracast-guide",
      models: []
    },
    NuEar: {
      url: "https://avantree.com/pages/nuear-hearing-aids-auracast-guide",
      models: []
    },
    Fortell: {
      url: "https://avantree.com/pages/fortell-hearing-aids-auracast-guide",
      models: []
    }
  };

  const escapeHtml = (value) => String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const isDirect = (row) => /^✓ Yes/.test(row.aur);
  const hasTelecoil = (row) => !/^✕ No/.test(row.tele);
  const hasPhonePath = (row) => !/^✕ No/.test(row.phone);
  const routeFor = {
    direct: (row) => isDirect(row),
    telecoil: (row) => !isDirect(row) && hasTelecoil(row),
    bluetooth: (row) => !isDirect(row) && hasPhonePath(row)
  };
  const routeMeta = [
    {
      key: "direct",
      title: "Direct Auracast",
      text: "Joins the venue broadcast directly—no separate receiver."
    },
    {
      key: "telecoil",
      title: "With T-coil Support",
      text: "Uses AuraCoil and the hearing aid’s T or MT program."
    },
    {
      key: "bluetooth",
      title: "With Bluetooth Streaming",
      text: "Uses Aura C, a compatible phone and Venucast Connect."
    }
  ];

  const hintFor = (row, route) => {
    if (route === "direct") {
      const hint = row.aur.replace(/^✓ Yes\s*[–-]?\s*/, "");
      return hint && hint !== row.aur ? hint : "";
    }
    if (route === "telecoil" && !/^✓ Yes$/.test(row.tele)) {
      return row.tele;
    }
    if (route === "bluetooth") {
      if (/wireless styles|model dependent|accessor|limited|Android via/i.test(row.phone)) return row.phone;
      if (/style-dependent|wireless styles|phone combination/i.test(row.note)) return "Confirm exact style and phone support.";
    }
    return "";
  };

  const rowsByYear = (rows) => {
    const years = new Map();
    rows
      .slice()
      .sort((a, b) => Number(b.year) - Number(a.year) || a.model.localeCompare(b.model))
      .forEach((row) => {
        if (!years.has(row.year)) years.set(row.year, []);
        years.get(row.year).push(row);
      });
    return years;
  };

  const brandLogo = (brand, assets, heading) => {
    const src = assets.brands[brand];
    if (src) {
      return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(brand) + '" loading="lazy"' + (heading ? ' width="145" height="45"' : ' width="86" height="35"') + ">";
    }
    return '<span class="brand-fallback">' + escapeHtml(brand) + "</span>";
  };

  document.querySelectorAll("[data-ha-compatibility]").forEach(async (root) => {
    if (root.dataset.haInitialized === "true") return;
    root.dataset.haInitialized = "true";

    const assets = JSON.parse(root.querySelector("[data-ha-assets]").textContent);
    let normalizedRows = [];
    try {
      const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRqcrRs43b8u0ULSY9jEeBAYntGMxyWEUqICiUaYEN1_lqUN2ZivsW1_IO00rKhio3sHN7i2dcNS7jr/pub?gid=0&single=true&output=csv" + "&_=" + Date.now(), { cache: "no-store" });
      if (!response.ok) throw new Error("Shared data unavailable");
      const csv = await response.text();
      const table = [];
      let fields = [], field = "", quoted = false;
      for (let i = 0; i < csv.length; i++) {
        const char = csv[i];
        if (char === '"') {
          if (quoted && csv[i + 1] === '"') { field += '"'; i++; }
          else quoted = !quoted;
        } else if (char === "," && !quoted) {
          fields.push(field); field = "";
        } else if ((char === "\n" || char === "\r") && !quoted) {
          if (char === "\r" && csv[i + 1] === "\n") i++;
          fields.push(field); table.push(fields); fields = []; field = "";
        } else field += char;
      }
      if (field || fields.length) { fields.push(field); table.push(fields); }
      const headers = table.shift().map((value) => value.replace(/^\uFEFF/, "").trim());
      const columns = ["Brand", "Model", "Release year", "Auracast support", "Telecoil support", "Phone streaming", "Notes", "Source URL"];
      if (columns.some((name) => !headers.includes(name))) throw new Error("Invalid shared data headers");
      normalizedRows = table.filter((values) => values.some((value) => value.trim())).map((values) => {
        const value = (name) => (values[headers.indexOf(name)] || "").trim();
        return { brand: value("Brand"), model: value("Model"), year: value("Release year"), aur: value("Auracast support"), tele: value("Telecoil support"), phone: value("Phone streaming"), note: value("Notes"), url: value("Source URL") };
      });
      if (normalizedRows.some((row) => !row.brand || !row.model)) throw new Error("Invalid shared data record");
    } catch (error) {
      normalizedRows = [];
    }
    const brandsEl = root.querySelector('[data-ha-role="brands"]');
    const brandNameEl = root.querySelector('[data-ha-role="brandname"]');
    const countEl = root.querySelector('[data-ha-role="count"]');
    const groupsEl = root.querySelector('[data-ha-role="groups"]');
    const detailEl = root.querySelector('[data-ha-role="detail"]');
    const directGuideEl = root.querySelector('[data-ha-role="direct-guide"]');
    const directGuideCoverEl = root.querySelector('[data-ha-role="direct-guide-cover"]');
    const directGuideCoverImageEl = root.querySelector('[data-ha-role="direct-guide-cover-image"]');
    const directScopeEl = root.querySelector('[data-ha-role="direct-scope"]');
    const directInstructionEl = root.querySelector('[data-ha-how="direct"] .how-card__content > div > p:not(.how-card__scope)');
    const howCards = Array.from(root.querySelectorAll("[data-ha-how]"));

    if (!normalizedRows.length) {
      brandsEl.innerHTML = "";
      brandNameEl.innerHTML = "<h2>Hearing aid compatibility</h2>";
      countEl.textContent = "Data temporarily unavailable";
      groupsEl.innerHTML = '<p class="empty">Hearing aid compatibility data is temporarily unavailable. Please try again later.</p>';
      detailEl.hidden = true;
      return;
    }

    const brands = Array.from(new Set(normalizedRows.map((row) => row.brand)))
      .sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }));
    let selectedBrand = brands[0];
    let selectedModel = null;

    const setGuide = (brand, row) => {
      const guide = BRAND_GUIDES[brand];
      const guideComingSoon = COMING_SOON_GUIDES.has(brand);
      const directSupported = normalizedRows.some((item) => item.brand === brand && isDirect(item));
      let href = guide ? guide.url : GENERIC_GUIDE;
      let scope = guideComingSoon
        ? "The " + brand + " connection guide is being prepared and will be available soon."
        : guide && guide.models.length
          ? "Current brand IUG covers: " + guide.models.join(", ") + "."
          : guide
            ? "Open the " + brand + " connection IUG."
            : "No brand-specific IUG is currently listed; this opens the general guide.";

      if (row && isDirect(row) && !guideComingSoon) {
        const covered = guide && (!guide.models.length || guide.models.some((model) => row.model === model || row.model.includes(model) || model.includes(row.model)));
        if (!covered) {
          href = GENERIC_GUIDE;
          scope = "General guide only; a verified " + row.model + " connection IUG is not currently listed.";
        } else {
          scope = "This IUG includes " + row.model + ".";
        }
      }

      directInstructionEl.textContent = directSupported ? DIRECT_INSTRUCTION : NO_DIRECT_SUPPORT;
      directGuideEl.hidden = !directSupported || guideComingSoon;
      directScopeEl.hidden = !directSupported;
      if (directSupported) {
        if (guideComingSoon) {
          directGuideEl.removeAttribute("href");
          directGuideEl.textContent = "";
          directScopeEl.classList.add("is-coming-soon");
          directScopeEl.innerHTML =
            '<span class="how-card__status">Coming soon</span>' +
            "<strong>Connection guide in preparation</strong>" +
            "<span>The " + escapeHtml(brand) + " guide will be available soon.</span>";
        } else {
          directGuideEl.href = href;
          directGuideEl.innerHTML = escapeHtml(brand) + ' connection IUG <span aria-hidden="true">→</span>';
          directScopeEl.classList.remove("is-coming-soon");
          directScopeEl.textContent = scope;
        }
      } else {
        directGuideEl.removeAttribute("href");
        directGuideEl.textContent = "";
        directScopeEl.classList.remove("is-coming-soon");
        directScopeEl.textContent = "";
      }

      const showBrandCover = false;
      directGuideCoverEl.hidden = !showBrandCover;
      if (showBrandCover) {
        directGuideCoverEl.href = guide.url;
        directGuideCoverEl.setAttribute("aria-label", "Open " + brand + " connection IUG");
        directGuideCoverImageEl.src = guide.cover;
        directGuideCoverImageEl.alt = brand + " Auracast connection IUG cover";
      } else {
        directGuideCoverImageEl.removeAttribute("src");
        directGuideCoverImageEl.alt = "";
      }
    };

    const setRelevantHowCard = (route) => {
      howCards.forEach((card) => card.classList.toggle("is-relevant", card.dataset.haHow === route));
    };

    const showDetail = (row, route) => {
      selectedModel = row;
      const routeValue = route === "direct" ? row.aur : route === "telecoil" ? row.tele : row.phone;
      const routeLabel = route === "direct" ? "Direct Auracast" : route === "telecoil" ? "T-coil support" : "Phone streaming";
      detailEl.innerHTML =
        "<h3>" + escapeHtml(row.brand + " " + row.model) + "</h3>" +
        "<p><strong>Model release year:</strong> " + escapeHtml(row.year) + "</p>" +
        "<p><strong>" + escapeHtml(routeLabel) + ":</strong> " + escapeHtml(routeValue) + "</p>" +
        "<p>" + escapeHtml(row.note) + "</p>" +
        '<div class="detail__links">' +
          '<a href="' + escapeHtml(row.url) + '" target="_blank" rel="noopener">Manufacturer source <span aria-hidden="true">→</span></a>' +
          '<a href="#how-to-use">Go to How to use <span aria-hidden="true">↓</span></a>' +
        "</div>";
      detailEl.hidden = false;
      setGuide(row.brand, row);
      setRelevantHowCard(route);
    };

    const renderRoute = (brandRows, meta) => {
      const routeRows = brandRows.filter(routeFor[meta.key]);
      if (!routeRows.length) {
        return '<article class="group ' + meta.key + '">' +
          "<h3>" + meta.title + "</h3>" +
          '<p class="explainer">' + meta.text + "</p>" +
          '<p class="empty">No verified models in this guide.</p>' +
        "</article>";
      }

      const yearHtml = Array.from(rowsByYear(routeRows)).map(([year, rows]) => {
        const modelHtml = rows.map((row) => {
          const hint = hintFor(row, meta.key);
          const hintHtml = hint ? '<span class="model-hint">' + escapeHtml(hint) + "</span>" : "";
          return '<button class="model" type="button" data-brand="' + escapeHtml(row.brand) + '" data-model="' + escapeHtml(row.model) + '" data-route="' + meta.key + '">' +
            '<span class="model-brand">' + escapeHtml(row.brand) + "</span>" +
            '<span class="model-name">' + escapeHtml(row.model) + "</span>" +
            hintHtml +
          "</button>";
        }).join("");
        return '<div class="yearrow"><strong>' + escapeHtml(year) + '</strong><div class="yearrow__models">' + modelHtml + "</div></div>";
      }).join("");

      return '<article class="group ' + meta.key + '">' +
        "<h3>" + meta.title + "</h3>" +
        '<p class="explainer">' + meta.text + "</p>" +
        '<div class="models">' + yearHtml + "</div>" +
      "</article>";
    };

    const renderBrand = (brand) => {
      selectedBrand = brand;
      selectedModel = null;
      const brandRows = normalizedRows.filter((row) => row.brand === brand);
      brandsEl.querySelectorAll("button").forEach((button) => {
        const active = button.dataset.brand === brand;
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
      });
      brandNameEl.innerHTML = brandLogo(brand, assets, true) + "<h2>" + escapeHtml(brand) + "</h2>";
      countEl.textContent = brandRows.length + (brandRows.length === 1 ? " model in the guide" : " models in the guide");
      groupsEl.innerHTML = routeMeta.map((meta) => renderRoute(brandRows, meta)).join("");
      groupsEl.querySelectorAll("button[data-model]").forEach((button) => {
        button.addEventListener("click", () => {
          const row = normalizedRows.find((item) => item.brand === button.dataset.brand && item.model === button.dataset.model);
          if (row) showDetail(row, button.dataset.route);
        });
      });
      detailEl.hidden = true;
      detailEl.innerHTML = "";
      setGuide(brand, null);
      setRelevantHowCard(null);
    };

    brandsEl.innerHTML = brands.map((brand, index) =>
      '<button type="button" role="tab" data-brand="' + escapeHtml(brand) + '" aria-selected="' + String(index === 0) + '" tabindex="' + (index === 0 ? "0" : "-1") + '">' +
        brandLogo(brand, assets, false) +
      "</button>"
    ).join("");

    brandsEl.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-brand]");
      if (button) renderBrand(button.dataset.brand);
    });

    brandsEl.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      const buttons = Array.from(brandsEl.querySelectorAll("button[data-brand]"));
      const current = buttons.indexOf(event.target.closest("button[data-brand]"));
      if (current < 0) return;
      event.preventDefault();
      let next = current;
      if (event.key === "ArrowLeft") next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === "ArrowRight") next = (current + 1) % buttons.length;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = buttons.length - 1;
      buttons[next].focus();
      renderBrand(buttons[next].dataset.brand);
    });

    renderBrand(selectedBrand);
  });
})();


P